import { tr } from '@/lib/i18n-core';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import type { EmailPauseDto } from '@his/shared';
import { get } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { visibleInterval } from '@/lib/polling';

const RECHECK_MS = 10 * 60_000;

export function EmailPausedBanner() {
  const { user, can } = useAuth();
  const staff = Boolean(user?.tenantId) && !user?.platformRole;

  const status = useQuery({
    queryKey: ['email-status', user?.tenantId],
    queryFn: () => get<EmailPauseDto>('/email/status'),
    enabled: staff,
    staleTime: RECHECK_MS,
    refetchInterval: visibleInterval(RECHECK_MS),
    refetchOnWindowFocus: false,
    retry: false,
  });

  if (!staff || !status.data?.paused) return null;

  return (
    <div className="flex flex-wrap items-center gap-3 border-b bg-amber-50 px-4 py-2 text-sm text-amber-900 dark:bg-amber-950/40 dark:text-amber-100 lg:px-6">
      <span className="flex-1">{tr('admin', 'email_banner')}</span>
      {can('tenant.settings.read', 'tenant.settings.manage') && (
        <Link className="font-medium underline underline-offset-2" to="/admin/settings?tab=email">
          {tr('admin', 'email_banner_open')}
        </Link>
      )}
    </div>
  );
}
